import { ResourceModel } from '../../product-category/models/resource.model';
import {
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  Output,
  EventEmitter
} from '@angular/core';
import * as moment from 'moment';
import { ProductCategoryService } from '../../product-category/services/product-category.service';
import {
  DxDataGridComponent,
} from 'devextreme-angular';
import { Subject } from "rxjs";
import notify from 'devextreme/ui/notify';
import {MomentDateAdapter} from '../../date-adapter/moment-date-adapter.class';

@Component({
  selector: 'app-resources-component',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.scss']
})
export class ResourcesComponent implements OnInit  {
  @Input() productCategorySelected: Subject<string>;
  @Input() selectedProductIdEvent: Subject<string>;
  @Input() isCommercial: boolean | null = null;
  @Input() hideFilteredResourcesEvent: Subject<boolean>;
  @Input() displayDownloadEvent: Subject<boolean>;
  @Input() archiveUrlEvent: Subject<string>;
  @Input() selectedCategoryInput: Subject<string>;
  @Input() selectedResourceTypeInput: Subject<string>;
  @Input() getResourcesEvent: Subject<boolean>;
  @Input() filteredCategory: string | null = null;
  @Input() filteredclass: string | null = null;
  @Input() showallresources = 'true';
  @Input() rolepermission: string;


  @Output() filteredResourcesEvent: EventEmitter<ResourceModel[]> = new EventEmitter<ResourceModel[]>();
  @Output() resetFiltersEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() categoriesEvent: EventEmitter<string[]> = new EventEmitter<string[]>();
  @Output() resourceTypesEvent: EventEmitter<string[]> = new EventEmitter<string[]>();

  selectedProductId: string;
  sorting = {
    date: 'desc',
    resourceType: null
  }
  hideFilteredResources: boolean = false;
  displayDownloadLink: boolean = false;
  archiveUrl: string = "";
  loading: boolean = true;
  loadingTimeout;
  allresources: ResourceModel[] = [];
  filteredresources: ResourceModel[] = [];
  categories: string[] = [];
  resourcetypes: string[] = [];
  selectedcategory: string;
  selectedresourcetype: string;
  resourceType: string;
  rolepermlist: string[] = [];
  inpreviewmode = false;
  momentdateadapter: MomentDateAdapter = new MomentDateAdapter();
  columnResizeMode = 'nextColumn';

  @ViewChild('resourcesdataGrid') resourcesdataGrid: DxDataGridComponent;
  @ViewChild('resourcesdataGrid') gridElement: ElementRef;
  @ViewChild('resourcesdataGridMobile')
  resourcesdataGridMobile: DxDataGridComponent;

  constructor(
    private service: ProductCategoryService,
    private hostElement: ElementRef,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.rolepermlist = this.rolepermission
      ? this.rolepermission.split(',')
      : [];

    const resourceTypeAtt = this.hostElement.nativeElement.getAttributeNode(
      'resourceType'
    );
    this.resourceType =
      resourceTypeAtt && resourceTypeAtt.value ? resourceTypeAtt.value : '';
    this.getResources();

    this.selectedResourceTypeInput.subscribe(resourceType => {
      this.selectedresourcetype = resourceType;
      this.selectResourceType();
    });

    this.selectedCategoryInput.subscribe(category => {
      this.selectedcategory = category;
      this.selectCategory();
    });

    this.displayDownloadEvent.subscribe((value) => {
      this.displayDownloadLink = value;
    });

    this.archiveUrlEvent.subscribe((value) => {
      this.archiveUrl = value;
    });

    this.hideFilteredResourcesEvent.subscribe((value) => {
      this.hideFilteredResources = value;
      if (value) {
        this.setFilteredResources([]);
      }
      else {
        this.setFilteredResources(this.filteredresources);
      }
    });

    this.getResourcesEvent.subscribe(reset => this.getResources(reset));

    this.productCategorySelected.subscribe(value => {
      if (value) {
        this.checkSorting("reset");
      }
      else {
        this.checkSorting("date");
      }
    });

    this.selectedProductIdEvent.subscribe(value => {
      this.selectedProductId = value;
      if (this.selectedProductId) {
        this.getResources();
        this.checkSorting("resourceType");
      }
    })
  }

  checkSorting(column: string) {
    for (let key in this.sorting) {
      if (key === column) {
        this.sorting[column] = "asc";
      }
      else {
        this.sorting[key] = null;
      }
    }
  }

  setFilteredResources(data: ResourceModel[], reset: boolean = false) {
    if (!this.hideFilteredResources || reset) {
      this.filteredresources = data;
      this.setNoDataText("No Data");
    }
    else {
      this.filteredresources = [];
      this.setNoDataText("Select a Product Type");
    }
    this.filteredResourcesEvent.emit(this.filteredresources);
    this.resourcesdataGrid.instance.option("dataSource", this.filteredresources);
  }

  setNoDataText(text: string) {
    this.resourcesdataGrid.noDataText = text;
  }

  selectCategory() {
    if (this.selectedcategory === 'All Categories') {
        // this.resourcesdataGrid.instance.clearFilter();
        // this.resourcesdataGridMobile.instance.clearFilter();
        this.setFilteredResources(this.allresources);
    } else {
        // this.resourcesdataGrid.instance.filter(['documentcategory', '=', data.value]);
        // this.resourcesdataGridMobile.instance.filter(['documentcategory', '=', data.value]);
      this.setFilteredResources(
        this.filteredresources.filter(x => x.documentcategory === this.selectedcategory)
      );
    }
    // if (this.selectedresourcetype !== 'All Resource Types') {
    //   // this.resourcesdataGrid.instance.filter(['documenttype', 'contains', this.selectedresourcetype]);
    //   // this.resourcesdataGridMobile.instance.filter(['documenttype', 'contains', this.selectedresourcetype]);
    //   this.setFilteredResources(
    //     this.filteredresources.filter(x => x.documenttype.includes(this.selectedresourcetype))
    //   );
    // }
    this.filterdropdowns();
    // this.setresourcetypevalues(data.value);
  }

  selectResourceType() {
    if (this.selectedresourcetype === 'All Resource Types') {
        // this.resourcesdataGrid.instance.clearFilter();
        // this.resourcesdataGridMobile.instance.clearFilter();
        this.setFilteredResources(this.allresources);
    } else {
        // this.resourcesdataGrid.instance.filter(['documenttype', 'contains', data.value]);
        // this.resourcesdataGridMobile.instance.filter(['documenttype', 'contains', data.value]);
      this.setFilteredResources(
        this.filteredresources.filter(x => x.documenttype.includes(this.selectedresourcetype))
      );
    }
    // if (this.selectedcategory !== 'All Categories') {
    //   // this.resourcesdataGrid.instance.filter(['documentcategory', '=', this.selectedcategory]);
    //   // this.resourcesdataGridMobile.instance.filter(['documentcategory', '=', this.selectedcategory]);
    //   this.setFilteredResources(
    //     this.filteredresources.filter(x => x.documentcategory === this.selectedcategory)
    //   );
    // }

    this.filterdropdowns();
    // this.setcategoryvalues(data.value);
  }

  filterdropdowns() {
    this.categories = [];
    this.resourcetypes = [];

    this.addDefaultCategory();
    this.addDefaultResourceType();
    this.filteredresources.forEach(r => {

        if (!this.categories.includes(r.documentcategory)) {
          if (r.documentcategory != null) {
            this.categories.push(r.documentcategory);
          }
        }

        r.documenttype.forEach(d => {
          if (!this.resourcetypes.includes(d)) {
            this.resourcetypes.push(d);
          }
        });

      });
     this.categories = this.categories.sort((a: string, b: string): number => {
      if (a > b) { return 1;}
      if (a < b) { return -1;}
      return 0;
    });
    this.categoriesEvent.emit(this.categories);

    this.resourcetypes = this.resourcetypes.sort((a: string, b: string): number => {
      if (a > b) { return 1;}
      if (a < b) { return -1;}
      return 0;
    });
    this.resourceTypesEvent.emit(this.resourcetypes);
  }

  getResources(reset: boolean = false) {
    this.startLoading();
    this.categories = [];
    this.resourcetypes = [];
    if (window !== window.top) {
      this.inpreviewmode = true;
    }
    this.allresources = [];
    this.service.getResourcesByProduct(this.selectedProductId, this.filteredCategory, this.filteredclass).subscribe(
      res => {
        let result: ResourceModel[] = [];
        let resourceArray: any[];
        resourceArray = res as any[];
        result = resourceArray
          ? resourceArray.map(item => new ResourceModel(item))
          : [];
        result.forEach(r => {

          var isRestrictedResource = r.folder === 'myLG HVAC Restricted';
          //var isUserAllowed = !this.rolepermlist[0] || r.permissions.some(r => this.rolepermlist.indexOf(r) >= 0);

          var isPublished = (!r.publishon || moment(r.publishon, 'YYYY-MM-DD').isSameOrBefore(moment())) && (!r.unpublishon || moment(r.unpublishon, 'YYYY-MM-DD').isAfter(moment()));
          if (!isPublished) {
            return;
          }

          if (this.showallresources == 'false') {
            if (isRestrictedResource) {
              this.allresources.push(r);
            }
          } else if (!isRestrictedResource) {
            this.allresources.push(r);
          }
        });

        this.setFilteredResources(this.allresources, reset);
        this.filterdropdowns();

        this.addDefaultCategory();
        this.selectedcategory = this.categories[0];
        this.allresources.forEach(r => {
          if (!this.categories.includes(r.documentcategory)) {
            if (r.documentcategory != null) {
              this.categories.push(r.documentcategory);
            }
          }
        });

        this.addDefaultResourceType();
        this.selectedresourcetype = this.resourcetypes[0];
        this.allresources.forEach(r => {
          r.documenttype.forEach(d => {
            if (!this.resourcetypes.includes(d)) {
              this.resourcetypes.push(d);
            }
          });
        });

        this.categoriesEvent.emit(this.categories);
        this.resourceTypesEvent.emit(this.resourcetypes);
        this.setLoadingState(false);
      },
      err =>
        notify(
          'There was an error getting resources. Please try again.',
          'error',
          3000
        )
    );

    // TODO: This is for testing purposes only
    // this.sampleresources();

    // this.filteredresources = this.allresources;

    // this.categories.push("All Categories");
    // this.selectedcategory = this.categories[0];
    // this.allresources.forEach(r => {
    //   if (!this.categories.includes(r.documentcategory)) {
    //     this.categories.push(r.documentcategory);
    //   }
    // })

    // this.resourcetypes.push("All Resource Types");
    // this.selectedresourcetype = this.resourcetypes[0];
    // this.allresources.forEach(r => {
    //   if (!this.resourcetypes.includes(r.documenttype)) {
    //     this.resourcetypes.push(r.documenttype);
    //   }
    // })
  }

  startLoading() {
    this.loadingTimeout = setTimeout(() => {
      this.setLoadingState(true);
    }, 1000);
  }

  setLoadingState(state) {
    clearTimeout(this.loadingTimeout);
    this.loading = state;
  }

  sampleresources() {

    for (let i = 1; i < 50; i++) {
      const resource = new ResourceModel();
      resource.id = i.toString();
      resource.documentcategory = 'category' + i.toString();
      resource.documenttype = ['resourcetype' + i.toString()];
      resource.documenturi =
        'http://unec.edu.az/application/uploads/2014/12/pdf-sample.pdf';
      resource.filetype = 'pdf';
      resource.name = 'resource' + i.toString();
      resource.permissions.push('sales');
      resource.publishon = '01/01/2018';
      resource.unpublishon = '12/31/2018';
      this.allresources.push(resource);
    }
  }


  downloadAllResources() {
    window.open(this.archiveUrl, "_blank");
  }

  addDefaultCategory() {
    const category = "All Categories";
    const index = this.categories.indexOf(category);
    if (index === -1) {
      this.categories.push(category);
    }
  }

  addDefaultResourceType() {
    const resourceType = "All Resource Types";
    const index = this.resourcetypes.indexOf(resourceType);
    if (index === -1) {
      this.resourcetypes.push(resourceType);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/components/resources.component.ts